import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cep' })
export class ZipCodePipe implements PipeTransform {

    transform(cep: string | number): string {
        const cepStr = '' + cep;

        if (cepStr.trim().length == 8) {
            return cepStr.replace(/^(\d{5})(\d)/, '$1-$2');
        } else {
            return cepStr;
        }
    }

}
